export default __webpack_public_path__ + "static/media/7.5f5340f3.jpg";